import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import White_Btn from "../../../common/common-btn/white-btn/White_Btn";
import Form_Header from "../../../common/form-header/Form_Header";
import "./Create_Step6.css";
import Preview_Modal from "../../../common/common-modal/preview-modal/Preview_Modal";
import Time_Modal from "../../../common/common-modal/time-modal/Time_Modal";
import { useRegistration } from "../../../../context/RegistrationContext";
import { submitStep6, getRegistrationProgress, getAmenities, getFacilities, getKeyServices } from "../../../../utils/gymOwnerApi";
import { getLocationDetails } from "../../../../utils/common";

const Create_Step6 = ({ step, totalSteps, setStep }) => {
  const navigate = useNavigate();
  const { userId, setRegistrationData } = useRegistration();
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [locationLoading, setLocationLoading] = useState(false);

  const [customErrors, setCustomErrors] = useState({});

  const {
    control,
    handleSubmit,
    setValue,
    register,
    trigger,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      key_services_id: [],
      close_days: [],
      schedule_1: "",
      schedule_2: "",
      gym_location: "",
      latitude: "",
      longitude: "",
      description: "",
      staff_count: "",
      amenities_id: [],
      other_facilities_id: [],
      working_day_from: "",
      working_day_to: "",
      close_day: "",
    },
  });

  const [step6View, setStep6View] = useState("form");
  const [modalShow, setModalShow] = useState(false);
  const [modalFile, setModalFile] = useState(null);
  const [showTimeModal, setShowTimeModal] = useState(false);
  const [isSchedule2, setIsSchedule2] = useState(false);

  const [openingTime, setOpeningTime] = useState("06:00");
  const [openingPeriod, setOpeningPeriod] = useState("AM");
  const [closingTime, setClosingTime] = useState("03:00");
  const [closingPeriod, setClosingPeriod] = useState("PM");

  const [schedule1, setSchedule1] = useState(null);
  const [schedule2, setSchedule2] = useState(null);

  const [allKeyServiceOptions, setAllKeyServiceOptions] = useState([]);
  const [allAmenitiesOptions, setAllAmenitiesOptions] = useState([]);
  const [allFacilitiesOptions, setAllFacilitiesOptions] = useState([]);
  const [selectedKeyServices, setSelectedKeyServices] = useState([]);

  const [selectedCloseDays, setSelectedCloseDays] = useState([]);
  const [selectedAmenities, setSelectedAmenities] = useState([]);
  const [selectedFacilities, setSelectedFacilities] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);

  const workoutFileRef = useRef(null);
  const [workoutImages, setWorkoutImages] = useState([]);
  const singleFileRef = useRef(null);
  const [singleFile, setSingleFile] = useState(null);

  const fileRefs = { cover: useRef(null), logo: useRef(null) };
  const [files, setFiles] = useState({ cover: null, logo: null });

  useEffect(() => {
    const loadProgress = async () => {
      if (!userId) return;
      setLoadingData(true);
      try {
        const [progressRes, amenitiesRes, facilitiesRes, keyServicesRes] = await Promise.all([
          getRegistrationProgress(),
          getAmenities(),
          getFacilities(),
          getKeyServices(),
        ]);

        if (!progressRes.success || !progressRes.data?.gym_detail) return;

        const data = progressRes.data;
        const gymDetail = data.gym_detail;
        const imgUrl = process.env.REACT_APP_IMG_URL || "";

        const allAmenities = amenitiesRes?.data || [];
        const allFacilities = facilitiesRes?.data || [];
        const allKeyServices = keyServicesRes?.data || [];

        setAllKeyServiceOptions(allKeyServices.map((s) => ({ value: s.id, label: s.name, ...s })));
        setAllAmenitiesOptions(allAmenities.map((a) => ({ value: a.id, label: a.name, ...a })));
        setAllFacilitiesOptions(allFacilities.map((f) => ({ value: f.id, label: f.name, ...f })));

        setValue("gym_location", gymDetail.gym_location || "");
        setValue("latitude", gymDetail.latitude || "");
        setValue("longitude", gymDetail.longitude || "");
        setValue("description", gymDetail.description || "");
        setValue("staff_count", gymDetail.staff_count || "");

        if (gymDetail.schedule_1) {
          setSchedule1({ value: gymDetail.schedule_1, label: gymDetail.schedule_1 });
          setValue("schedule_1", gymDetail.schedule_1);
        }
        if (gymDetail.schedule_2) {
          setSchedule2({ value: gymDetail.schedule_2, label: gymDetail.schedule_2 });
          setValue("schedule_2", gymDetail.schedule_2);
        }
        if (data.close_days?.length) {
          const closeDayOptions = data.close_days.map((d) => ({ value: d, label: d }));
          setSelectedCloseDays(data.close_days);
          setValue("close_days", closeDayOptions);
        }

        if (data.key_services_id?.length) {
          const matched = allKeyServices.filter((s) => data.key_services_id.includes(s.id));
          setSelectedServices(matched);
          setSelectedKeyServices(matched.map((s) => s.id));
          setValue("key_services_id", matched.map((s) => s.id));
        }

        if (data.amenities_id?.length) {
          const matched = allAmenities.filter((a) => data.amenities_id.includes(a.id));
          setSelectedAmenities(matched);
          setValue("amenities_id", matched.map((a) => a.id));
        }

        if (data.other_facilities_id?.length) {
          const matched = allFacilities.filter((f) => data.other_facilities_id.includes(f.id));
          setSelectedFacilities(matched);
          setValue("other_facilities_id", matched.map((f) => f.id));
        }

        if (gymDetail.cover_photo)
          setFiles((p) => ({ ...p, cover: { preview: `${imgUrl}${gymDetail.cover_photo}` } }));
        if (gymDetail.gym_logo)
          setFiles((p) => ({ ...p, logo: { preview: `${imgUrl}${gymDetail.gym_logo}` } }));

        if (data.gym_photos?.length) {
          setWorkoutImages(
            data.gym_photos.map((photo) => ({ preview: `${imgUrl}${photo.gym_photos}` }))
          );
        }

        setRegistrationData(data);
      } catch (error) {
        console.error("Error loading progress:", error);
      } finally {
        setLoadingData(false);
      }
    };
    loadProgress();
  }, [userId, setValue, setRegistrationData]);

  const handleNextToImages = async () => {
    const rhfValid = await trigger(["close_days", "gym_location", "latitude", "longitude", "description", "staff_count"]);

    const newCustomErrors = {};
    if (selectedServices.length === 0) newCustomErrors.key_services_id = "Please select at least one key service";
    if (!schedule1) newCustomErrors.schedule_1 = "Schedule 1 is required";

    setCustomErrors(newCustomErrors);

    if (!rhfValid || Object.keys(newCustomErrors).length > 0) return;

    setStep6View("images");
  };

  const validateImagesView = () => {
    const newCustomErrors = {};
    if (selectedAmenities.length === 0) newCustomErrors.amenities_id = "Please select at least one amenity";
    if (selectedFacilities.length === 0) newCustomErrors.other_facilities_id = "Please select at least one facility";
    if (!files.cover) newCustomErrors.cover_photo = "Cover photo is required";
    if (!files.logo) newCustomErrors.gym_logo = "Gym logo is required";
    setCustomErrors(newCustomErrors);
    return Object.keys(newCustomErrors).length === 0;
  };

  const onSubmitStep6 = async (data) => {
    if (!validateImagesView()) return;
    if (!userId) { alert("Please complete previous steps first"); setStep(1); return; }

    setLoading(true);
    try {
      const formData = new FormData();

      formData.append("user_id", userId);
      formData.append("schedule_1", schedule1?.value || data.schedule_1);
      formData.append("schedule_2", schedule2?.value || data.schedule_2);
      formData.append("gym_location", data.gym_location);
      formData.append("latitude", data.latitude);
      formData.append("longitude", data.longitude);
      formData.append("description", data.description);
      formData.append("staff_count", data.staff_count);

      formData.append("key_services_id", JSON.stringify(selectedServices.map((s) => s.id)));
      formData.append("close_days", JSON.stringify(selectedCloseDays));
      formData.append("amenities_id", JSON.stringify(selectedAmenities.map((a) => a.id)));
      formData.append("other_facilities_id", JSON.stringify(selectedFacilities.map((f) => f.id)));

      if (files.cover?.file) formData.append("cover_photo", files.cover.file);
      if (files.logo?.file) formData.append("gym_logo", files.logo.file);

      workoutImages
        .filter((img) => img.file)
        .forEach((img, index) => formData.append(`gym_photos[${index}]`, img.file));

      await submitStep6(formData);
      setStep(7);
    } catch (error) {
      console.error("Error submitting step 6:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDone = (forSchedule2 = false) => {
    const label = `${openingTime} ${openingPeriod} - ${closingTime} ${closingPeriod}`;
    if (forSchedule2) {
      setSchedule2({ value: label, label });
      setValue("schedule_2", label);
      setCustomErrors((prev) => ({ ...prev, schedule_2: undefined }));
    } else {
      setSchedule1({ value: label, label });
      setValue("schedule_1", label);
      setCustomErrors((prev) => ({ ...prev, schedule_1: undefined }));
    }
    setShowTimeModal(false);
  };

  const handleServicesChange = (selectedOptions) => {
    const services = selectedOptions || [];
    const normalised = services.map((o) => ({ id: o.value, name: o.label }));
    setSelectedServices(normalised);
    setSelectedKeyServices(normalised.map((s) => s.id));
    setValue("key_services_id", normalised.map((s) => s.id));
    if (services.length > 0)
      setCustomErrors((prev) => ({ ...prev, key_services_id: undefined }));
  };

  const handleAmenitiesChange = (selectedOptions) => {
    const items = (selectedOptions || []).map((o) => ({ id: o.value, name: o.label }));
    setSelectedAmenities(items);
    setValue("amenities_id", items.map((i) => i.id));
    if (items.length > 0)
      setCustomErrors((prev) => ({ ...prev, amenities_id: undefined }));
  };

  const handleFacilitiesChange = (selectedOptions) => {
    const items = (selectedOptions || []).map((o) => ({ id: o.value, name: o.label }));
    setSelectedFacilities(items);
    setValue("other_facilities_id", items.map((i) => i.id));
    if (items.length > 0)
      setCustomErrors((prev) => ({ ...prev, other_facilities_id: undefined }));
  };

  const openPreviewModal = (file) => { setModalFile(file); setModalShow(true); };

  const handleFileChange = (type, e) => {
    const file = e.target.files[0];
    if (file) {
      setFiles((prev) => ({ ...prev, [type]: { file, name: file.name, preview: URL.createObjectURL(file) } }));
      setCustomErrors((prev) => ({ ...prev, [`${type === "cover" ? "cover_photo" : "gym_logo"}`]: undefined }));
    }
  };

  const handleButtonClick = (type) => {
    if (files[type]?.preview) openPreviewModal(files[type]);
    else fileRefs[type].current.click();
  };

  const handleWorkoutClick = () => workoutFileRef.current.click();
  const handleWorkoutChange = (e) => {
    const newImages = Array.from(e.target.files).map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setWorkoutImages((prev) => [...prev, ...newImages]);
  };
  const removeWorkoutImage = (index) =>
    setWorkoutImages((prev) => prev.filter((_, i) => i !== index));

  const handleSingleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) setSingleFile({ file, name: file.name, preview: URL.createObjectURL(file) });
  };
  const handleSingleButtonClick = () => {
    if (singleFile?.preview) openPreviewModal(singleFile);
    else singleFileRef.current.click();
  };

  const handleGetLocation = async () => {
    try {
      setLocationLoading(true);
      const location = await getLocationDetails();

      if (!location) {
        alert("Unable to fetch location. Please enter manually.");
        return;
      }

      setValue("gym_location", location.formatted_address || "");
      setValue("latitude", String(location.latitude || ""));
      setValue("longitude", String(location.longitude || ""));

      setCustomErrors((prev) => ({ ...prev, gym_location: undefined }));
    } catch (error) {
      console.error("Location error:", error);
      alert("Failed to fetch location. Please enter manually.");
    } finally {
      setLocationLoading(false);
    }
  };

  const daysOptions = [
    { value: "Monday", label: "Monday" },
    { value: "Tuesday", label: "Tuesday" },
    { value: "Wednesday", label: "Wednesday" },
    { value: "Thursday", label: "Thursday" },
    { value: "Friday", label: "Friday" },
    { value: "Saturday", label: "Saturday" },
    { value: "Sunday", label: "Sunday" },
  ];


  /* ─────────────────── IMAGES VIEW ─────────────────────────── */
  if (step6View === "images") {
    return (
      <>
        <section className="step3_wrapper step1_wrapper step4_wrapper step6_wrapper">
          <Form_Header title="Upload Gym Images" subtitle="" step={6} totalSteps={7} />

          <div className="container mt-4">
            <div className="row mt-4">

              {/* Amenities — inline multi-select */}
              <div className="col-lg-12 mb-4">
                <Form.Group>
                  <Form.Label>
                    Amenities Offered <span className="text-danger">*</span>
                  </Form.Label>
                  <Select
                    isMulti
                    options={allAmenitiesOptions}
                    placeholder="Select Amenities"
                    className={`react-select-container ${customErrors.amenities_id ? "is-invalid-select" : ""}`}
                    classNamePrefix="react-select"
                    value={selectedAmenities.map((a) => ({ value: a.id, label: a.name }))}
                    onChange={handleAmenitiesChange}
                  />
                  {customErrors.amenities_id && (
                    <div className="text-danger mt-1" style={{ fontSize: "0.875em" }}>
                      {customErrors.amenities_id}
                    </div>
                  )}
                </Form.Group>
              </div>

              {/* Facilities — inline multi-select */}
              <div className="col-lg-12 mb-4">
                <Form.Group>
                  <Form.Label>
                    Other Facilities <span className="text-danger">*</span>
                  </Form.Label>
                  <Select
                    isMulti
                    options={allFacilitiesOptions}
                    placeholder="Select Facilities"
                    className={`react-select-container ${customErrors.other_facilities_id ? "is-invalid-select" : ""}`}
                    classNamePrefix="react-select"
                    value={selectedFacilities.map((f) => ({ value: f.id, label: f.name }))}
                    onChange={handleFacilitiesChange}
                  />
                  {customErrors.other_facilities_id && (
                    <div className="text-danger mt-1" style={{ fontSize: "0.875em" }}>
                      {customErrors.other_facilities_id}
                    </div>
                  )}
                </Form.Group>
              </div>

              {/* Cover Photo + Logo */}
              {[
                { label: "Cover Photo", key: "cover", errorKey: "cover_photo" },
                { label: "Gym Logo", key: "logo", errorKey: "gym_logo" },
              ].map((item) => (
                <div className="col-lg-6 mb-4" key={item.key}>
                  <Form.Group>
                    <Form.Label>
                      {item.label} <span className="text-danger">*</span>
                    </Form.Label>
                    <div className={`file_upload_wrapper ${customErrors[item.errorKey] ? "border-danger" : ""}`}>
                      <span className="file_placeholder">
                        {files[item.key] ? files[item.key].name : "No File Uploaded"}
                      </span>
                      <div className="upload_btn" onClick={() => handleButtonClick(item.key)}>
                        <Common_Btn btnText={files[item.key] ? "Preview" : "Upload file"} />
                      </div>
                      <input
                        ref={fileRefs[item.key]}
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={(e) => handleFileChange(item.key, e)}
                      />
                    </div>
                    {customErrors[item.errorKey] && (
                      <div className="text-danger mt-1" style={{ fontSize: "0.875em" }}>
                        {customErrors[item.errorKey]}
                      </div>
                    )}
                  </Form.Group>
                </div>
              ))}

              {/* Workout Space */}
              <div className="col-lg-12">
                <Form.Label>Workout Space</Form.Label>
                <div className="workout_upload_wrapper">
                  <div className="add_photo_box" onClick={handleWorkoutClick}>
                    <div className="plus_sign_div">
                      <span className="plus_sign">+</span>
                    </div>
                    <p className="add_photo">Add Photo</p>
                  </div>
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    hidden
                    ref={workoutFileRef}
                    onChange={handleWorkoutChange}
                  />
                  <div className="workout_images_container">
                    {workoutImages.map((img, index) => (
                      <div className="workout_image_card" key={index}>
                        <img src={img.preview} alt="Workout" className="workout_img" />
                        <span className="remove_image" onClick={() => removeWorkoutImage(index)}>✕</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="form_btn_holder">
              <White_Btn btnText="Back" onClick={() => setStep6View("form")} />
              <Common_Btn
                btnText={loading ? "Submitting..." : "Next"}
                onClick={handleSubmit(onSubmitStep6)}
                disabled={loading}
              />
            </div>
          </div>
        </section>

        <Preview_Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          file={modalFile}
          onUploadNew={() => {
            if (modalFile === singleFile) singleFileRef.current.click();
            else {
              const key = Object.keys(files).find((k) => files[k] === modalFile);
              fileRefs[key]?.current.click();
            }
          }}
          onDelete={() => {
            if (modalFile === singleFile) setSingleFile(null);
            else {
              const key = Object.keys(files).find((k) => files[k] === modalFile);
              setFiles((prev) => ({ ...prev, [key]: null }));
            }
            setModalShow(false);
          }}
        />

        {/* Facilitiy_Modal and Aminities_Modal removed — now use inline multi-select */}
      </>
    );
  }

  /* ─────────────────── FORM VIEW ───────────────────────────── */
  if (step6View === "form") {
    return (
      <>
        <section className="step3_wrapper step1_wrapper step4_wrapper step6_wrapper">
          <Form_Header title="About Gold's Gym" subtitle="" step={6} totalSteps={7} />

          <div className="container">
            <Form className="auth_form">
              <div className="row">

                {/* Key Services — inline multi-select (no modal) */}
                <div className="col-lg-12 mb-4">
                  <Form.Group>
                    <Form.Label>
                      Key Services Offered <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                      isMulti
                      options={allKeyServiceOptions}
                      placeholder="Select key services"
                      className={`react-select-container ${customErrors.key_services_id ? "is-invalid-select" : ""}`}
                      classNamePrefix="react-select"
                      value={selectedServices.map((s) => ({ value: s.id, label: s.name }))}
                      onChange={handleServicesChange}
                    />
                    {customErrors.key_services_id && (
                      <div className="text-danger mt-1" style={{ fontSize: "0.875em" }}>
                        {customErrors.key_services_id}
                      </div>
                    )}
                  </Form.Group>
                </div>

                {/* Close Days */}
                <div className="col-lg-6 mb-4">
                  <Form.Group>
                    <Form.Label>
                      Close Days <span className="text-danger">*</span>
                    </Form.Label>
                    <Controller
                      name="close_days"
                      control={control}
                      rules={{ required: "Please select at least one close day" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={daysOptions}
                          placeholder="Select Days"
                          className={`react-select-container ${errors.close_days ? "is-invalid-select" : ""}`}
                          classNamePrefix="react-select"
                          isMulti
                          onChange={(val) => {
                            field.onChange(val);
                            setSelectedCloseDays(val ? val.map((v) => v.value) : []);
                          }}
                          value={field.value || []}
                        />
                      )}
                    />
                    {errors.close_days && (
                      <div className="text-danger mt-1" style={{ fontSize: "0.875em" }}>
                        {errors.close_days.message}
                      </div>
                    )}
                  </Form.Group>
                </div>

                {/* Schedule 1 */}
                <div className="col-lg-6 mb-4">
                  <Form.Group>
                    <Form.Label>
                      Schedule 1 <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                      value={schedule1}
                      placeholder="Enter Time"
                      onMenuOpen={() => { setIsSchedule2(false); setShowTimeModal(true); }}
                      menuIsOpen={false}
                      className={`react-select-container ${customErrors.schedule_1 ? "is-invalid-select" : ""}`}
                      classNamePrefix="react-select"
                    />
                    {customErrors.schedule_1 && (
                      <div className="text-danger mt-1" style={{ fontSize: "0.875em" }}>
                        {customErrors.schedule_1}
                      </div>
                    )}
                  </Form.Group>
                </div>

                {/* Schedule 2 */}
                <div className="col-lg-6 mb-4">
                  <Form.Group>
                    <Form.Label>
                      Schedule 2 <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                      value={schedule2}
                      placeholder="Enter Time"
                      onMenuOpen={() => { setIsSchedule2(true); setShowTimeModal(true); }}
                      menuIsOpen={false}
                      className={`react-select-container ${customErrors.schedule_2 ? "is-invalid-select" : ""}`}
                      classNamePrefix="react-select"
                    />
                    {customErrors.schedule_2 && (
                      <div className="text-danger mt-1" style={{ fontSize: "0.875em" }}>
                        {customErrors.schedule_2}
                      </div>
                    )}
                  </Form.Group>
                </div>

                {/* Geo Location */}
                <div className="col-lg-11 mb-2">
                  <Form.Group>
                    <Form.Label>
                      Geo Location <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter manually or tap the icon →"
                      isInvalid={!!errors.gym_location}
                      {...register("gym_location", {
                        required: "Gym location is required",
                      })}
                    />
                    <Form.Control
                      type="hidden"
                      {...register("latitude", {
                        required: "Please fetch or enter a valid location with coordinates",
                      })}
                    />
                    <Form.Control
                      type="hidden"
                      {...register("longitude", {
                        required: "Please fetch or enter a valid location with coordinates",
                      })}
                    />
                    {(errors.gym_location || errors.latitude || errors.longitude) && (
                      <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
                        {errors.gym_location?.message ||
                          errors.latitude?.message ||
                          errors.longitude?.message}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                </div>

                {/* Location Icon */}
                <div className="col-lg-1 mb-2 d-flex align-items-center" style={{ paddingTop: "28px" }}>
                  <div
                    className="location_icon_holder"
                    onClick={!locationLoading ? handleGetLocation : undefined}
                    title="Fetch my current location"
                    style={{ cursor: locationLoading ? "wait" : "pointer", textAlign: "center" }}
                  >
                    <FontAwesomeIcon
                      icon={faLocationDot}
                      style={{
                        fontSize: "25px",
                        color: locationLoading ? "#aaa" : undefined,
                      }}
                    />
                    {locationLoading && (
                      <small style={{ display: "block", fontSize: "10px", whiteSpace: "nowrap" }}>
                        Fetching…
                      </small>
                    )}
                  </div>
                </div>

                <div className="col-lg-12 mb-2" />

                {/* Description */}
                <div className="col-lg-12 mb-4">
                  <Form.Group>
                    <Form.Label>
                      Gym Description (Max. 500 characters) <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Gym Description"
                      isInvalid={!!errors.description}
                      {...register("description", {
                        required: "Description is required",
                        maxLength: { value: 500, message: "Max 500 characters allowed" },
                      })}
                    />
                    {errors.description && (
                      <Form.Control.Feedback type="invalid">
                        {errors.description.message}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                </div>

                {/* Staff Count */}
                <div className="col-lg-6 mb-4">
                  <Form.Group>
                    <Form.Label>
                      Total Staff Count <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Enter Staff Count"
                      isInvalid={!!errors.staff_count}
                      {...register("staff_count", {
                        required: "Staff count is required",
                        min: { value: 1, message: "Staff count must be at least 1" },
                        max: { value: 1000, message: "Staff count cannot exceed 1000" },
                        pattern: { value: /^[0-9]+$/, message: "Only numbers are allowed" },
                      })}
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-", "."].includes(e.key)) e.preventDefault();
                      }}
                    />
                    {errors.staff_count && (
                      <Form.Control.Feedback type="invalid">
                        {errors.staff_count.message}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                </div>

              </div>
            </Form>

            <div className="form_btn_holder">
              <White_Btn btnText="Back" onClick={() => setStep(5)} />
              <Common_Btn btnText="Next" onClick={handleNextToImages} disabled={loading} />
            </div>
          </div>
        </section>

        <Time_Modal
          show={showTimeModal}
          onHide={() => setShowTimeModal(false)}
          openingTime={openingTime} setOpeningTime={setOpeningTime}
          openingPeriod={openingPeriod} setOpeningPeriod={setOpeningPeriod}
          closingTime={closingTime} setClosingTime={setClosingTime}
          closingPeriod={closingPeriod} setClosingPeriod={setClosingPeriod}
          onDone={() => handleDone(isSchedule2)}
        />

        {/* Key_Services_Modal removed — no longer needed */}
      </>
    );
  }

  return null;
};

export default Create_Step6;